import React from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import { percentageFormat } from "lib/formats";

import { useTranslation } from "react-i18next";

export default function ChartTooltip({ pointerX, pointerY, value, name }) {
  const { t } = useTranslation();

  if (value == null) {
    return <div />;
  }

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 1,
        pointerEvents: "none",
        left: pointerX,
        top: pointerY,
      }}
    >
      <Card>
        <CardContent>
          <Typography color="textSecondary" variant="body1">
            {name}
          </Typography>
          <Typography color="textSecondary" variant="caption">
            {value > 1 ? t("map.moreThan100") : percentageFormat(value)}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
}
